import ReactDOM from "react-dom/client";
import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { App } from "./app";

const root = ReactDOM.createRoot(document.getElementById("root"));
const basePath = process.env.REACT_APP_PREFIX;

root.render(
  <HelmetProvider>
    <BrowserRouter basename={`${basePath}`}>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>,
);
